import { createStore } from '@stencil/store';
import { AppData } from './data.types';

const initialState: AppData = new AppData();

const { state, reset, onChange } = createStore(initialState);

export const dataStore = {
  state,
  reset,
  onChange,
};